import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row date-scheduler"
}
const _hoisted_2 = { class: "col-12 date-select mb-3" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "col-12 date-select mb-3"
}
const _hoisted_5 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_visit_time_select = _resolveComponent("visit-time-select")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "Date & Time", -1)),
            _createElementVNode("div", null, [
              _createVNode(_component_datepicker, {
                class: "float-start",
                "lower-limit": _ctx.startDate,
                "upper-limit": _ctx.endDate,
                "disabled-dates": {dates: _ctx.disabledDates},
                placeholder: "Select Date...",
                modelValue: _ctx.dateSelect,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dateSelect) = $event)),
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateSelected(1)))
                ]
              }, null, 8, ["lower-limit", "upper-limit", "disabled-dates", "modelValue"]),
              (_ctx.timeSelect)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    innerHTML: _ctx.timeSelect,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dateSelected(1))),
                    class: "time-select-format"
                  }, null, 8, _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
            _createVNode(_component_visit_time_select, {
              times: _ctx.times,
              display: _ctx.timeDisplay,
              field: 'timeSelect',
              onUpdateTime: _ctx.setTime
            }, null, 8, ["times", "display", "onUpdateTime"])
          ]),
          (!_ctx.is_single)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _cache[8] || (_cache[8] = _createElementVNode("span", null, "Alternate Date & Time", -1)),
                _createElementVNode("div", null, [
                  _createVNode(_component_datepicker, {
                    class: "float-start",
                    "lower-limit": _ctx.startDate,
                    "upper-limit": _ctx.endDate,
                    "disabled-dates": {dates: _ctx.disabledDates},
                    placeholder: "Select Date...",
                    modelValue: _ctx.altDateSelect,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.altDateSelect) = $event)),
                      _cache[4] || (_cache[4] = ($event: any) => (_ctx.dateSelected(2)))
                    ]
                  }, null, 8, ["lower-limit", "upper-limit", "disabled-dates", "modelValue"]),
                  (_ctx.altTimeSelect)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        innerHTML: _ctx.altTimeSelect,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dateSelected(2))),
                        class: "time-select-format"
                      }, null, 8, _hoisted_5))
                    : _createCommentVNode("", true)
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "clear-both" }, null, -1)),
                _createVNode(_component_visit_time_select, {
                  times: _ctx.altTimes,
                  display: _ctx.altTimeDisplay,
                  field: 'altTimeSelect',
                  onUpdateTime: _ctx.setTime
                }, null, 8, ["times", "display", "onUpdateTime"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}